/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DataModelRangeAnalysisJobPoint = {
    value: number;
    status: DataModelRangeAnalysisJobPoint.status;
    companyJobId: number;
    jobTitle?: string;
    jobCode?: string;
    jobFamilyTitle?: string;
};

export namespace DataModelRangeAnalysisJobPoint {

    export enum status {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

